if (!Element.prototype.matches)
{
    // @ts-ignore phpstorm lie! msMatchesSelector exists in internet explorer
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest)
{
    Element.prototype.closest = function(searchString: string)
    {
        let element = this as HTMLElement;

        do
        {
            if (element.matches(searchString))
            {
                return element;
            }

            element = (element.parentElement || element.parentNode) as HTMLElement;
        }
        while (element !== null && element.nodeType === 1);

        return null;
    };
}

// Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/prepend()/prepend().md
(function (arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty('prepend')) {
            return;
        }
        Object.defineProperty(item, 'prepend', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function prepend() {
                var argArr = Array.prototype.slice.call(arguments),
                    docFrag = document.createDocumentFragment();

                argArr.forEach(function (argItem) {
                    var isNode = argItem instanceof Node;
                    docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                });

                this.insertBefore(docFrag, this.firstChild);
            }
        });
    });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

export {};